/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdditionalBillingProfileAddress } from './';
import {
    AdditionalBillingProfileAddressFromJSON,
    AdditionalBillingProfileAddressFromJSONTyped,
    AdditionalBillingProfileAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdditionalBillingProfileResource
 */
export interface AdditionalBillingProfileResource {
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileResource
     */
    clientLegalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileResource
     */
    label: string;
    /**
     * 
     * @type {AdditionalBillingProfileAddress}
     * @memberof AdditionalBillingProfileResource
     */
    address: AdditionalBillingProfileAddress;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileResource
     */
    registrationNumber?: string;
}

/**
 * Check if a given object implements the AdditionalBillingProfileResource interface.
 */
export function instanceOfAdditionalBillingProfileResource(value: object): value is AdditionalBillingProfileResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('clientLegalEntityId' in value) || value['clientLegalEntityId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function AdditionalBillingProfileResourceFromJSON(json: any): AdditionalBillingProfileResource {
    return AdditionalBillingProfileResourceFromJSONTyped(json, false);
}

export function AdditionalBillingProfileResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalBillingProfileResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientLegalEntityId': json['clientLegalEntityId'],
        'label': json['label'],
        'address': AdditionalBillingProfileAddressFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
    };
}

export function AdditionalBillingProfileResourceToJSON(value?: AdditionalBillingProfileResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'clientLegalEntityId': value['clientLegalEntityId'],
        'label': value['label'],
        'address': AdditionalBillingProfileAddressToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
    };
}

